<template>
  <div id="index">
    <el-row :gutter="10">
      <el-col :span="12">
        <div class="content-box">
          <el-row>
            <el-col :span="22">
              <div id="operateMainBar" style="width:600px;height:400px;"></div>
            </el-col>
            <el-col :span="2">
              <div id="contextMenu" class="back" v-if="isOperate" @click="operateBack">返回</div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="content-box">
          <el-row>
            <el-col :span="22">
              <div id="inspanMainBar" style="width:600px;height:400px;"></div>
            </el-col>
            <el-col :span="2">
              <div id="contextMenu" class="back" v-if="isInspan" @click="inspanBack">返回</div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="12">
        <div class="content-box">
          <el-row>
            <el-col :span="22">
              <div id="fixMainBar" style="width:600px;height:400px;"></div>
            </el-col>
            <el-col :span="2">
              <div id="contextMenu" class="back" v-if="isFix" @click="fixBack">返回</div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="content-box">
          <el-row>
            <el-col :span="22">
              <div id="planMainBar" style="width:600px;height:400px;"></div>
            </el-col>
            <el-col :span="2">
              <div id="contextMenu" class="back" v-if="isPlan" @click="planBack">返回</div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="18">
        <div class="content-box">
          <div class="index-title">
            <i class="icon-plan index-title-icon"></i>
            <span class="index-title-main">待办事项</span>
          </div>
          <el-form inline-message :model="searchList" label-width="80px">
            <el-col :span="6">
              <el-form-item label="任务类型" prop="app">
                <el-select v-model="searchList.app" clearable placeholder="请选择" size="small" style="width: 100%">
                  <el-option v-for="(data,index) in selectData" :key="index" :value="data.description" :label="data.description"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="开始日期">
                <el-date-picker size="small" v-model="searchList.starttime" placeholder="选择日期" type="date" style="width:100%" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="结束日期">
                <el-date-picker size="small" v-model="searchList.endtime" placeholder="选择日期" type="date" style="width:100%" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="line-height:40px">
              <el-button icon="icon-search" class="btn btn-blue" size="mini" type="primary" @click="searchBtn">搜索</el-button>
              <el-button icon="icon-refresh" class="btn-blue" size="mini" @click="resetBtn">重置</el-button>
            </el-col>
          </el-form>
          <el-table ref="table" stripe :data="todoList" style="width: 100%;" height="220" v-loading="todoloading" element-loading-text="加载中…" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)">
            <el-table-column type="index" label="序号" width="50">
              <template slot-scope="scope">
                <span> {{(todoListpage.currentPage-1)*todoListpage.pageSize+scope.$index+1}} </span>
              </template>
            </el-table-column>
            <el-table-column label="单据号" sortable width="160px" prop="bizNum" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <p class="blue" title="点击查看详情" @click="todotaskView(scope.row)">{{scope.row.bizNum}}</p>
              </template>
            </el-table-column>
            <el-table-column label="单据描述" width="300" sortable prop="bizDesc" :show-overflow-tooltip="true">
            </el-table-column>

            <el-table-column label="任务类型" sortable width="160" prop="appDesc" :show-overflow-tooltip="true">
            </el-table-column>
            <!-- <el-table-column label="详细描述" sortable prop="description" :show-overflow-tooltip="true">
             </el-table-column>-->
            <el-table-column label="当前环节" width="120" sortable prop="name" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column label="状态" sortable prop="bizStatus" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column label="意见说明" width="140" sortable prop="bizOpinion" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column label="接收时间" sortable width="160px" prop="createTime" :show-overflow-tooltip="true">
            </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next,sizes,total,jumper" :current-page="todoListpage.currentPages" :page-sizes="[10, 20, 30, 40]" :page-size="todoListpage.pageSize" :total="todoListpage.totalCount" @size-change="todosizeChange" @current-change="todocurrentChange"></el-pagination>
        </div>
        <div class="content-box">
          <div class="index-title">
            <i class="icon-wordbook index-title-icon"></i>
            <span class="index-title-main">已办事项</span>
          </div>
          <el-form inline-message :model="doneList" label-width="80px">
            <el-col :span="6">
              <el-form-item label="任务类型" prop="app">
                <el-select v-model="doneList.app" clearable placeholder="请选择" size="small" style="width: 100%">
                  <el-option v-for="(data,index) in selectData" :key="index" :value="data.description" :label="data.description"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="开始日期">
                <el-date-picker size="small" v-model="doneList.getstarttime" placeholder="选择日期" type="date" style="width:100%" value-format="yyyy-MM-dd" @change="dateChange('start')"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="结束日期">
                <el-date-picker size="small" v-model="doneList.getendtime" placeholder="选择日期" type="date" style="width:100%" value-format="yyyy-MM-dd" @change="dateChange('end')"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="line-height:40px">
              <el-button icon="icon-search" class="btn btn-blue" size="mini" type="primary" @click="searchDoneBtn">搜索</el-button>
              <el-button icon="icon-refresh" class="btn-blue" size="mini" @click="resetDoneBtn">重置</el-button>
            </el-col>
          </el-form>
          <el-table ref="table" stripe :data="completedList" style="width: 100%;" height="220" v-loading="completedloading" element-loading-text="加载中…" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)">
            <el-table-column type="index" label="序号" width="50">
              <template slot-scope="scope">
                <span> {{(completedListpage.currentPage-1)*completedListpage.pageSize+scope.$index+1}} </span>
              </template>
            </el-table-column>
            <el-table-column label="单据号" sortable width="160px" prop="bizNum" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <p class="blue" title="点击查看详情" @click="todotaskView(scope.row)">{{scope.row.bizNum}}</p>
              </template>
            </el-table-column>
            <el-table-column label="单据描述" width="300" sortable prop="bizDesc" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column label="任务类型" sortable width="160" prop="appDesc" :show-overflow-tooltip="true">
            </el-table-column>
            <!--
            <el-table-column label="详细描述" sortable prop="description" :show-overflow-tooltip="true">
            </el-table-column>
            -->
            <el-table-column label="当前环节" width="120" sortable prop="name" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column label="状态" sortable prop="bizStatus" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column label="意见说明" width="140" sortable prop="bizOpinion" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column label="办理/提交时间" sortable width="160px" prop="endTime" :show-overflow-tooltip="true">
            </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next,sizes,total,jumper" :current-page="completedListpage.currentPages" :page-sizes="[10, 20, 30, 40]" :page-size="completedListpage.pageSize" :total="completedListpage.totalCount" @size-change="completedsizeChange" @current-change="completedcurrentChange"></el-pagination>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="content-box">
          <div class="index-title">
            <i class="icon-bar-chart-2 index-title-icon"></i>
            <span class="index-title-main">工作完成情况</span>
          </div>
          <div style="height:262px;padding:10px">
            <el-row>
              <el-col :span="12">
                <div class="allTasktotal">{{toDoNum + toDoDing}}</div>
                <div class="alltotal">工作总计</div>
                <div class="todotasktotal">待办工作: {{toDoNum}}</div>
                <div class="completedtotal">已办工作: {{toDoDing}}</div>
              </el-col>
              <el-col class="allcircle" :span="12">
                <el-progress type="circle" :percentage="complete" :width="150"></el-progress>
                <div>工作完成率</div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="content-box">
          <div class="index-title">
            <i class="tkicon-notice index-title-icon"></i>
            <span class="index-title-main">公告</span>
          </div>
          <div class="notice-box">
            <div class="notice-list">
              <span class="notice-icon">注意</span>
              <el-tooltip class="item" effect="dark" content="恒信启华应用管理中心2.0版本创建" placement="bottom">
                <span class="notice-title">恒信启华应用管理中心2.0版本创建</span>
              </el-tooltip>
              <span class="notice-time">2020-11-25</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog class="tododialog" :append-to-body="true" :fullscreen="true" :visible.sync="tododialog" width="100%" @close="closetododialog">
      <detailPages ref="detailPages"></detailPages>
    </el-dialog>
  </div>
</template>

<script>

import detailPages from '@/components/customPagesOne/detailPages.vue'
var echarts = require('echarts');
export default {
  name: 'index',
  components: { detailPages },
  data() {
    return {
      basic_url: Config.dev_url,
      todoList: [],
      todoListpage: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      },
      todoloading: false,
      completedList: [],
      completedListpage: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      },
      searchList: {
        app: '',
        starttime: '',
        endtime: ''
      },
      doneList: {
        app: '',
        getstarttime: '',
        getendtime: ''
      },
      selectData: [],
      completedloading: false,
      toDoNum: 0,//待办工作
      toDoDing: 0,//已办任务
      complete: 0,
      tododialog: false,
      isInspan: false,
      isOperate: false,
      isFix: false,
      isPlan: false,
      operateOption: {
        title: {
          top: 15,
          left: 20,
          text: '操作工点检完成率'
        },
        color: ['#D7504B'],
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          top: 100,
          right: 80,
          bottom: 80,
          left: 60
        },
        legend: {
          top: 40,
          left: 'center',
          data: ['操作工点检']
        },
        xAxis: {
          axisLabel: {
            interval: 0,
            rotate: 35
          },
          //显示策略，可选为：true（显示） | false（隐藏），默认值为true
          show: true,
          //坐标轴类型，横轴默认为类目型'category'
          type: 'category',
          //类目型坐标轴文本标签数组，指定label内容。 数组项通常为文本，'\n'指定换行
          data: []
        },
        yAxis: [
          {
            type: 'value',
            name: "操\n作\n工\n点\n检\n完\n成\n率\n︵\n%\n︶",
            nameLocation: "center",
            nameGap: 35,
            nameRotate: 0,
            nameTextStyle: {
              fontSize: 12,
            },
            min: 0,  //取0为最小刻度
            max: 100, //取100为最大刻度
            //默认以千分位显示，不想用的可以在这加一段
            axisLabel: {   //调整左侧Y轴刻度， 直接按对应数据显示
              show: true,
              showMinLabel: true,
              showMaxLabel: true,
              formatter: function (value) {
                return value;
              }
            }
          },
        ],
        series: [
          {
            name: '操作工点检完成率',
            type: 'bar',
            yAxisIndex: 0,
            data: [],
            // itemStyle : { normal: {label : {show: true}}},
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                // { type: 'min', name: '最小值' }
              ]
            }
          }
        ]
      },
      inspanOption: {
        color: ['#61a0a8'],
        title: {
          top: 15,
          left: 20,
          text: '点检员点检完成率'
        },
        tooltip: {
          trigger: 'axis',
          //   formatter: "{a} <br/>{b} : {c}"
        },
        grid: {
          top: 100,
          right: 80,
          bottom: 80,
          left: 60
        },
        legend: {
          top: 40,
          left: 'center',
          data: ['点检员点检']
        },
        xAxis: {
          axisLabel: {
            interval: 0,
            rotate: 35
          },
          //显示策略，可选为：true（显示） | false（隐藏），默认值为true
          show: true,
          //坐标轴类型，横轴默认为类目型'category'
          type: 'category',
          //类目型坐标轴文本标签数组，指定label内容。 数组项通常为文本，'\n'指定换行
          data: []
        },
        yAxis: [
          {
            type: 'value',
            name: "点\n检\n员\n点\n检\n完\n成\n率\n︵\n%\n︶",
            nameLocation: "center",
            nameGap: 35,
            nameRotate: 0,
            nameTextStyle: {
              fontSize: 12,
            },
            min: 0,  //取0为最小刻度
            max: 100, //取100为最大刻度
            //默认以千分位显示，不想用的可以在这加一段
            axisLabel: {   //调整左侧Y轴刻度， 直接按对应数据显示
              show: true,
              showMinLabel: true,
              showMaxLabel: true,
              formatter: function (value) {
                return value;
              }
            }
          }
        ],
        series: [
          {
            name: '点检员点检',
            type: 'bar',
            yAxisIndex: 0,
            data: [],
            // itemStyle: { normal: { label: { show: true } } },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                // { type: 'min', name: '最小值' }
              ]
            }
          }
        ]
      },
      fixOption: {
        color: ['#91c7ae'],
        title: {
          top: 15,
          left: 20,
          text: '维修工点检完成率'
        },
        tooltip: {
          trigger: 'axis',
          //   formatter: "{a} <br/>{b} : {c}"
        },
        grid: {
          top: 100,
          right: 80,
          bottom: 80,
          left: 60
        },
        legend: {
          top: 40,
          left: 'center',
          data: ['维修工点检']
        },
        xAxis: {
          axisLabel: {
            interval: 0,
            rotate: 35
          },
          //显示策略，可选为：true（显示） | false（隐藏），默认值为true
          show: true,
          //坐标轴类型，横轴默认为类目型'category'
          type: 'category',
          //类目型坐标轴文本标签数组，指定label内容。 数组项通常为文本，'\n'指定换行
          data: []
        },
        yAxis: [
          {
            type: 'value',
            name: "维\n修\n工\n点\n检\n完\n成\n率\n︵\n%\n︶",
            nameLocation: "center",
            nameGap: 35,
            nameRotate: 0,
            nameTextStyle: {
              fontSize: 12,
            },
            min: 0,  //取0为最小刻度
            max: 100, //取100为最大刻度
            //默认以千分位显示，不想用的可以在这加一段
            axisLabel: {   //调整左侧Y轴刻度， 直接按对应数据显示
              show: true,
              showMinLabel: true,
              showMaxLabel: true,
              formatter: function (value) {
                return value;
              }
            }
          }
        ],
        series: [
          {
            name: '维修工点检',
            type: 'bar',
            yAxisIndex: 0,
            data: [],
            // itemStyle: { normal: { label: { show: true } } },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                // { type: 'min', name: '最小值' }
              ]
            }
          }
        ]
      },
      planOption: {
        title: {
          top: 15,
          left: 20,
          text: '检修计划完成率'
        },
        tooltip: {
          trigger: 'axis',
          //   formatter: "{a} <br/>{b} : {c}"
        },
        grid: {
          top: 100,
          right: 80,
          bottom: 80,
          left: 60
        },
        legend: {
          top: 40,
          left: 'center',
          data: ['计划检修', '定期维护']
        },
        xAxis: {
          axisLabel: {
            interval: 0,
            rotate: 35
          },
          //显示策略，可选为：true（显示） | false（隐藏），默认值为true
          show: true,
          //坐标轴类型，横轴默认为类目型'category'
          type: 'category',
          //类目型坐标轴文本标签数组，指定label内容。 数组项通常为文本，'\n'指定换行
          data: []
        },
        yAxis: [
          {
            type: 'value',
            name: "计\n划\n检\n修\n完\n成\n率\n︵\n%\n︶",
            nameLocation: "center",
            nameGap: 35,
            nameRotate: 0,
            nameTextStyle: {
              fontSize: 12,
            },
            min: 0,  //取0为最小刻度
            max: 100, //取100为最大刻度
            //默认以千分位显示，不想用的可以在这加一段
            axisLabel: {   //调整左侧Y轴刻度， 直接按对应数据显示
              show: true,
              showMinLabel: true,
              showMaxLabel: true,
              formatter: function (value) {
                return value;
              }
            }
          },
          {
            type: 'value',
            name: "定\n期\n维\n护\n完\n成\n率\n︵\n%\n︶",
            nameLocation: "center",
            nameGap: 50,
            nameRotate: 0,
            nameTextStyle: {
              fontSize: 12,
            },
            min: 0,  //取0为最小刻度
            max: 100, //取100为最大刻度
            //默认以千分位显示，不想用的可以在这加一段
            axisLabel: {   //调整左侧Y轴刻度， 直接按对应数据显示
              show: true,
              showMinLabel: true,
              showMaxLabel: true,
              formatter: function (value) {
                return value;
              }
            }
          }
        ],
        series: [
          {
            name: '计划检修',
            type: 'bar',
            yAxisIndex: 0,
            data: [],
            // itemStyle: { normal: { label: { show: true } } },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                // { type: 'min', name: '最小值' }
              ]
            }
          },
          {
            name: '定期维护',
            type: 'bar',
            yAxisIndex: 1,
            data: [],
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                // { type: 'min', name: '最小值' }
              ]
            }
          }
        ]
      },
    }
  },
  methods: {
    //关闭待办任务
    closetododialog() {
      this.gettodoList()
      this.getcompletedList()
      let request1 = this.getTodoNumber();//待办数量
      let request2 = this.getTodoDing();//已办数量
      Promise.all([request1, request2]).then(() => {
        this.getop();
      })

    },
    //待办任务跳转
    todotaskView(item) {
      this.tododialog = true
      //通用解析详情
      this.$nextTick(() => {
        if (!!item.app && !!item.appid && !item.bizMenuUrl) {
          this.$route.params.app = item.app              //应用app名称
          this.$route.query.appid = item.appid           //应用appid
          this.$refs.detailPages.todoViewDetail(item)    //通用解析详情组件
        }
      })
    },
    todosizeChange(val) {
      this.todoListpage.pageSize = val
      this.gettodoList()
    },
    todocurrentChange(val) {
      this.todoListpage.currentPage = val
      this.gettodoList()
    },
    //重置按钮
    resetBtn() {
      this.searchList.app = '';
      this.searchList.starttime = '';
      this.searchList.endtime = '';
      this.todoListpage.currentPage = 1;
      this.gettodoList();
      this.getTodoNumber()
    },
    //搜索
    searchBtn() {
      this.todoListpage.currentPage = 1;
      this.gettodoList();
      this.getTodoNumber('search')
    },
    //待办任务
    gettodoList() {
      var data = {
        page: this.todoListpage.currentPage,
        limit: this.todoListpage.pageSize,
        iscount: false,
      }
      this.todoloading = true
       for (let key in this.searchList) {
        if (this.searchList[key] == '') {
          this.$delete(this.searchList, key)
        }
      }
      var obj = Object.assign(data, this.searchList);
      var url = Config.dev_url + '/api-apps/app/flow/flow/todo';
      this.$axios.get(url, { params: obj }).then((res) => {
        this.todoloading = false
        this.todoList = res.data.data;
      }).catch((err) => {
        this.todoloading = false
      });
    },
    completedsizeChange(val) {
      this.completedListpage.pageSize = val
      this.getcompletedList()
    },
    completedcurrentChange(val) {
      this.completedListpage.currentPage = val
      this.getcompletedList()
    },
    //已办重置
    resetDoneBtn() {
      this.doneList.app = '';
      this.doneList.getstarttime = '';
      this.doneList.getendtime = '';
      this.completedListpage.currentPage = 1;
      this.getcompletedList();
      this.getTodoDing()
    },
    //已办搜索
    searchDoneBtn() {
      this.completedListpage.currentPage = 1;
      this.getcompletedList();
      this.getTodoDing('search')
    },
    //已办任务
    getcompletedList() {
      var data = {
        page: this.completedListpage.currentPage,
        limit: this.completedListpage.pageSize,
        iscount: false,
      }
      this.completedloading = true;
      for (let key in this.doneList) {
        if (this.doneList[key] == '') {
          this.$delete(this.doneList, key)
        }
      }
      var obj = Object.assign(data, this.doneList);
      var url = Config.dev_url + '/api-apps/app/flow/flow/findCompletedItemsNoRepeat';
      this.$axios.get(url, { params: obj }).then((res) => {
        this.completedloading = false;
        this.completedList = res.data.data;
      }).catch((err) => {
        this.completedloading = false
      });
    },
    getTodoNumber(str) {//获取当前用户待办任务数
      return new Promise((resove, reject) => {
        if(str == 'search'){
          var obj = Object.assign({}, this.searchList);
        }else{
          var obj = {}
        }
        var url = Config.dev_url + '/api-apps/app/flow/flow/todocount';
        this.$axios.get(url, { params: obj }).then((res) => {
          if(str != 'search') this.toDoNum = res.data;
          this.todoListpage.totalCount = res.data;
          resove()
        }).catch((err) => {
        });
      })
    },
    getTodoDing(str) {//获取当前用户执行中
      return new Promise((resove, reject) => {
          if(str == 'search'){
            var obj = Object.assign({}, this.doneList);
          }else{
            var obj = {}
          }
          var url = Config.dev_url + '/api-apps/app/flow/flow/findCompletedItemsNoRepeatCount';
          this.$axios.get(url, { params: obj }).then((res) => {
            if(str != 'search') this.toDoDing = res.data;
            this.completedListpage.totalCount = res.data;
          }).catch((err) => {
          });
          resove()
      })
    },
    getop() {
      this.complete = this.toDoDing + this.toDoNum == 0 ? 0 : Number((this.toDoDing / (this.toDoDing + this.toDoNum) * 100).toFixed(2));//工作完成率
    },
    initOperateBar() {
      let inspanMainBar = echarts.init(document.getElementById("inspanMainBar"));
      inspanMainBar.setOption(this.inspanOption);
    },
    planBack() {
      this.isPlan = false;
      this.getBarData();
    },
    //获取检修计划柱状图数据
    getBarData(deptname) {
      const _this = this;
      var data = {
        username: this.$store.state.currentuser.username,
        deptname: deptname,
      }
      var url = Config.dev_url + '/api-apps/app/fixplanApp/operate/fixplanGraph';
      this.$axios.post(url, data).then((res) => {
        let planMainBar = echarts.init(document.getElementById("planMainBar"));
        this.planOption.xAxis.data = res.data.fullname;
        this.planOption.series[0].data = res.data.plannedmaintenance;
        this.planOption.series[1].data = res.data.regularmaintenance;
        planMainBar.setOption(this.planOption);
        planMainBar.on('click', function (params) {
          if (params.componentType == "series") {
            _this.isPlan = true;
            _this.getBarData(params.name)
          }
        })
      }).catch((err) => {
      });
    },
    //操作工返回
    operateBack() {
      this.isOperate = false;
      this.getOperateData();
    },
    //获取操作工点检完成率柱状图数据
    getOperateData(deptname) {
      const _this = this;
      var data = {
        username: this.$store.state.currentuser.username,
        deptname: deptname,
        inspectype: '操作工点检'
      }
      var url = Config.dev_url + '/api-apps/app/inspectionApp/operate/jockeyGraph';
      this.$axios.post(url, data).then((res) => {
        let operateMainBar = echarts.init(document.getElementById("operateMainBar"));
        this.operateOption.xAxis.data = res.data.fullname;
        this.operateOption.series[0].data = res.data.completionrate;
        operateMainBar.setOption(this.operateOption);
        operateMainBar.on('click', function (params) {
          if (params.componentType == "series") {
            _this.isOperate = true;
            _this.getOperateData(params.name)
          }
        })
      }).catch((err) => {
      });
    },
    //点检员返回
    inspanBack() {
      this.isInspan = false;
      this.getInspanData();
    },
    //获取点检员点检完成率柱状图数据
    getInspanData(deptname) {
      const _this = this;
      var data = {
        username: this.$store.state.currentuser.username,
        deptname: deptname,
        inspectype: '点检员点检'
      }
      var url = Config.dev_url + '/api-apps/app/inspectionApp/operate/jockeyGraph';
      this.$axios.post(url, data).then((res) => {
        let inspanMainBar = echarts.init(document.getElementById("inspanMainBar"));
        _this.inspanOption.xAxis.data = res.data.fullname;
        _this.inspanOption.series[0].data = res.data.completionrate;
        inspanMainBar.setOption(_this.inspanOption);
        inspanMainBar.on('click', function (params) {
          console.log(params)
          if (params.componentType == "series") {
            _this.isInspan = true;
            _this.getInspanData(params.name)
          }
        })
      }).catch((err) => {
      });
    },
    //维修工返回
    fixBack() {
      this.isFix = false;
      this.getFixData();
    },
    //获取维修工点检完成率柱状图数据
    getFixData(deptname) {
      const _this = this;
      var data = {
        username: this.$store.state.currentuser.username,
        deptname: deptname,
        inspectype: '维修工点检'
      }
      var url = Config.dev_url + '/api-apps/app/inspectionApp/operate/jockeyGraph';
      this.$axios.post(url, data).then((res) => {
        let fixMainBar = echarts.init(document.getElementById("fixMainBar"));
        this.fixOption.xAxis.data = res.data.fullname;
        this.fixOption.series[0].data = res.data.completionrate;
        fixMainBar.setOption(this.fixOption);
        fixMainBar.on('click', function (params) {
          console.log(params)
          if (params.componentType == "series") {
            _this.isFix = true;
            _this.getFixData(params.name)
          }
        })
      }).catch((err) => {
      });
    },
    //获取任务类型
    getFlowType() {
      var url = Config.dev_url + '/api-apps/customization/selectPcAppByflow';
      this.$axios.post(url, {}).then((res) => {
        this.selectData = res.data.data;
      }).catch((err) => {
      });
    },
  },
  created() {
    let request1 = this.getTodoNumber();//待办数量
      let request2 = this.getTodoDing();//已办数量
      Promise.all([request1, request2]).then(() => {
        this.getop();
      })

  },
  mounted() {
    this.getFlowType();
    this.gettodoList()
    this.getcompletedList()
    this.$nextTick(() => {
      this.initOperateBar();
      this.getOperateData()
      this.getInspanData()
      this.getFixData()
      this.getBarData();
    });
    this.$store.commit("setisShowLeftMenu", true)
    setTimeout(() => {
      this.getop()
    }, 1000)
  }
}
</script>

<style lang="less">
#index {
  .back {
    float: right;
    margin-top: 12px;
    margin-right: 10px;
  }
  .back:hover {
    cursor: pointer;
  }
  .allcircle {
    text-align: center;
    color: #606266;
    margin-top: 20px;
  }
  .allTasktotal {
    font-size: 50px;
    color: #606266;
    margin-left: 20px;
  }
  .alltotal {
    font-size: 14px;
    font-weight: 700;
    color: #606266;
    margin-left: 20px;
  }
  .todotasktotal {
    color: orangered;
    margin-top: 60px;
    font-size: 14px;
    margin-left: 20px;
  }
  .completedtotal {
    margin-top: 10px;
    color: #606266;
    font-size: 14px;
    margin-left: 20px;
  }
  .notice-box {
    width: 100%;
    height: 310px;
    padding: 0px 10px 10px 10px;
    overflow-y: scroll;
  }
  .notice-list {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0px 10px;
    display: flex;
    align-items: center;
    .notice-icon {
      background-color: #fdf6ec;
      border-color: #faecd8;
      color: #e6a23c;
      padding: 0px 10px;
      font-size: 12px;
      border-width: 1px;
      border-style: solid;
      border-radius: 4px;
      white-space: nowrap;
      margin-right: 10px;
      display: inline-block;
      line-height: 24px;
      height: 24px;
    }
    .notice-title {
      width: 160px;
      height: 40px;
      line-height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .notice-time {
      flex: 1;
      text-align: right;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .notice-list:hover {
    background-color: #f5f7fa;
    cursor: pointer;
  }
  .content-box {
    width: 100%;
    background: #ffffff;
    border: 1px solid rgb(230, 230, 230);
    margin-bottom: 10px;
    box-shadow: 0 2px 12px 0 rgba(151, 148, 148, 0.2);
    .index-title {
      width: 100%;
      height: 30px;
      margin: 10px;
      .index-title-icon {
        display: inline-block;
        background: #2d3651;
        width: 30px;
        height: 30px;
        color: #ffffff;
        text-align: center;
        line-height: 30px;
        border-radius: 3px;
        font-size: 18px;
        vertical-align: middle;
        margin-right: 10px;
      }
      .index-title-main {
        font-size: 16px;
        font-weight: 600;
        vertical-align: middle;
      }
    }
  }
}
</style>
